import * as Font from 'expo-font';

export const getZdfFonts = () => {
  return Font.loadAsync({
    ZdfMedium: require('assets/zdf/fonts/ZDFType-Medium.ttf'),
    ZdfRegular: require('assets/zdf/fonts/ZDFType-Regular.ttf'),
    ZdfSemiBold: require('assets/zdf/fonts/ZDFType-SemiBold.ttf'),
  });
};